import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { environment } from 'src/environments/environment';
import { EntregaProjeto } from '../../models/entregas-projeto.model';
import { EntregasProjetoService } from '../../services/entregas-projeto.service';
import { NavigationService } from '../../services/navigation.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-detalhe-entrega-projeto-view',
  templateUrl: './detalhe-entrega-projeto-view.component.html',
  styleUrls: ['./detalhe-entrega-projeto-view.component.scss']
})
export class DetalheEntregaProjetoViewComponent extends BaseListComponent<EntregaProjeto> implements OnInit, OnDestroy {

  idProjeto: number;
  infoProjeto: any;
  entrega: EntregaProjeto;
  modalPrintRef?: BsModalRef;
  audit: any;
  infoImprimir?: any = {
    analises: true,
    pontos: true,
    planos: true,
    cronograma: true,
  };

  @ViewChild('modalPrint') modalPrint: TemplateRef<any>;

  constructor(
    private myService: EntregasProjetoService,
    private activatedRoute: ActivatedRoute,
    private modalService: BsModalService,
    private pesquisaGeralService: PesquisaGeralService,
    private navigation: NavigationService
  ) {
    super()
  }

  ngOnInit(): void {
    this.entrega = this.activatedRoute.snapshot.data['entity'];
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.entrega.project = info;
      this.idProjeto = this.infoProjeto.id;
      this.audit = { prt_issue_id: this.entrega.id };
      this.loaded();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  bloqueioEntregaProjeto(total: boolean = false) {
    this.loading()
    let obj = {};
    if (total) {
      obj = {
        full_blocked: this.entrega?.full_blocked ? "0" : "1",
      };
    } else {
      obj = {
        meta_blocked: this.entrega?.meta_blocked ? "0" : "1",
      };
    }
    this.addSub(
      this.myService.getBloqueio(this.entrega.id, obj).subscribe({
        next: (res) => {
          if (total) {
            this.entrega.full_blocked = !this.entrega.full_blocked;
          } else {
            this.entrega.meta_blocked = !this.entrega?.meta_blocked;
          }
          this.loaded();
          this.msgSuccess(res?.message);
        },
        error: (err) => {
          this.loaded();
          this.msgError(err.error?.message);
        },
      }),
    )
  }

  voltar() {
    this.navigation.back(['projetos', 'projeto', this.idProjeto, 'entregas']);
  }

  closePrintModal() {
    this.modalPrintRef?.hide();
  }

  openPrintModal() {
    this.modalPrintRef = this.modalService.show(this.modalPrint);
  }

  imprimir(){
    this.loading();
    const url = `${environment.serverUrl}/rest/relatorios/entrega/${this.entrega?.id}?analises=${this.infoImprimir?.analises}&pontos=${this.infoImprimir?.pontos}&planos=${this.infoImprimir?.planos}&cronograma=${this.infoImprimir?.cronograma}`;
    window.open(url,'_blank');
    this.loaded();
  }
}
